import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { BottomNavigationAction, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { ReactComponent as ExerciseIcon } from '../../../assets/icons/menu/exercise.svg';
import { ReactComponent as MenuIcon } from '../../../assets/icons/menu/menu.svg';
import { ReactComponent as ProgramIcon } from '../../../assets/icons/menu/program.svg';
import { ReactComponent as StatisticIcon } from '../../../assets/icons/menu/statistic.svg';
import { ReactComponent as TrainingIcon } from '../../../assets/icons/menu/training.svg';
import { useBackLayerStack } from '../../../context/BackLayerStackContext';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';
import { useStyles } from './Footer.styles';

function Footer(props) {
  const { setShowMenu } = props;
  const { t } = useTranslation();
  // const messagesCount = Math.sum(
  //   ...Object.values(unreadMessages).map((item) => item.length),
  // );
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const location = useLocation();
  const { replaceFull } = useNavigationStack();
  const { tryDismissTop } = useBackLayerStack();

  const menuItems = [
    {
      icon: <ExerciseIcon />,
      label: t('common.exercises'),
      link: Paths.exercises.toList,
      isActiveChecLink: Paths.exercises.root,
      onboardingKey: 'general.footer.exercises',
    },
    {
      icon: <ProgramIcon />,
      label: t('menu.programs'),
      link: Paths.programs.toList,
      isActiveChecLink: Paths.programs.root,
      onboardingKey: 'general.footer.programs',
    },

    {
      icon: <TrainingIcon />,
      label: t('menu.trainings'),
      link: Paths.trainings.toList,
      main: true,
      isActiveChecLink: Paths.trainings.root,
      onboardingKey: 'general.footer.trainings',
    },
    {
      icon: <StatisticIcon />,
      label: t('menu.statistics'),
      link: Paths.statistics.toCalendar,
      isActiveChecLink: Paths.statistics.root,
      onboardingKey: 'general.footer.statistics',
    },
    // {
    //   icon: <PersonIcon />,
    //   label: t('common.myProfile'),
    //   link: Paths.users.me,
    // },
  ];

  function isActiveTab(item) {
    // if (item.link === Paths.root) return location.pathname === item.link;

    return location.pathname.indexOf(item.isActiveChecLink) !== -1;
  }

  function handleFooterAction(action: () => void) {
    if (tryDismissTop(action)) {
      return;
    }
    action();
  }

  return (
    <footer className={classes.footerWrapper}>
      <Box className={classes.footerItemsWrapper}>
        {menuItems.map((item) => (
          <React.Fragment key={item.label}>
            <Box className={classes.footerItemWrapper}>
              <BottomNavigationAction
                data-onboarding={item.onboardingKey}
                className={clsx(classes.footerItemButton, {
                  [classes.mainFooterItemButton]: item.main,
                  [classes.active]: isActiveTab(item),
                })}
                onClick={() => handleFooterAction(() => replaceFull(item.link))}
                icon={item.icon}
                label={item.label}>
                {/*{!!item.counter && <span className={classes.counter}>{item.counter < 100 ? item.counter : '99+'}</span>}*/}
              </BottomNavigationAction>
            </Box>
          </React.Fragment>
        ))}

        <Box className={classes.footerItemWrapper}>
          <BottomNavigationAction
            className={classes.footerItemButton}
            onClick={() => setShowMenu(true)}
            icon={<MenuIcon />}
            label={t('menu.menu')}></BottomNavigationAction>
        </Box>
      </Box>
    </footer>
  );
}

export default Footer;
